import {
    Badge, Box,
    Button,
    ButtonGroup,
    CardActions,
    CardHeader,
    Divider,
    Grid2, Stack,
} from "@mui/material";
import {useContext, useEffect, useMemo, useState} from "react";
import Card from "@mui/material/Card";
import {Link, NavLink, Outlet, useNavigate} from "react-router-dom";
import AuthContext from "../Services/AuthContext";
import {Add, Delete, Edit, Event, Person} from "@mui/icons-material";
import Main from "../Layout/Main";
import AddChildren from "../Panel/Children/AddChildren";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import EditChildren from "../Panel/Children/EditChildren";
import Subnavigation from "../Component/Subnavigation";

function ChildrenAdvanced() {
    const [user] = useContext(AuthContext);
    const [items, setItems] = useState([]);
    const [refresh, setRefresh] = useState(0);

    const [addChildren, setAddChildren] = useState(false);
    const [editChildren, setEditChildren] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        if (user.token === "") {
            navigate("/");
        }
    }, [user.token, navigate]);

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchData() {
            await fetch(`/api/children`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setItems(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [user, refresh]);

    function _delete(id) {
        fetch(`/api/children/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(() => {
                setRefresh(r => ++r);
            })
            .catch(err => {
                console.log(err)
            })
    }
    const subNav = useMemo(() => <Subnavigation items={[
        {to: 'overview', name: 'Podsumowanie', color: 'info'},
        {to: 'details', name: 'Dane', color: 'info'},
        {to: 'allowed', name: 'Opiekuni', color: 'success'},
        {to: 'agreement', name: 'Zgody', color: 'warning'},
        {to: 'document', name: 'Dokumenty', color: 'warning'}
    ]}/>, []);

    const cards = items.map((item) =>                     <NavLink to={'overview'} style={{textDecoration: 'none', color: 'black'}}>
        <ListItemButton
            selected={selectedIndex === item.id}
            onClick={() => setSelectedIndex(item.id)}
        >
            <ListItemIcon>
                <Person />
            </ListItemIcon>
            <ListItemText primary={`${item.name} ${item.surname}`} />
        </ListItemButton></NavLink>);
    return (<Main title={'Dokumenty Kwalifikacyjne'}>
        <Stack direction="row" spacing={2} flexWrap={'wrap'} sx={{maxWidth: '95vw', width: '95vw'}}>
            <Box sx={{ width: '100%', maxWidth: '360px', bgcolor: 'background.paper' }}>
                <List component="nav" aria-label="main mailbox folders">
                    <ListItemButton
                        onClick={() => setAddChildren(true)}
                    >
                        <ListItemIcon>
                            <Add />
                        </ListItemIcon>
                        <ListItemText primary="Dodaj Dziecko" />
                    </ListItemButton>
                </List>
                <Divider />
                <List component="nav" to={'overview'} aria-label="secondary mailbox folder">
                    {cards}
                </List>
            </Box>
            {selectedIndex !== null && <Box sx={{ minWidth: '360px', flexGrow: 1, bgcolor: 'background.paper', padding: '10px 30px 50px 30px', textAlign: 'left'}}>
                {subNav}
                <Outlet context={{children: selectedIndex}}/>
            </Box>}
        </Stack>
        <AddChildren isOpen={addChildren} dismiss={() => setAddChildren(false)} onSuccess={() => setRefresh(r => ++r)} />
    </Main>);
}

export default ChildrenAdvanced;